import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls, useRelations } from '@hooks/useProviderPackage'

const ProviderPackageListItem = (props) => {
  const { providerPackage, providerPackage: { price, title } } = props

  const { editProviderPackageUrl } = generateUrls(providerPackage)

  const { provider } = useRelations(providerPackage)

  return (
    <DashboardModuleListItem
      href={editProviderPackageUrl}
      secondaryText={provider?.title}
      title={title}
    >
      <DashboardModuleListItem.TertiaryText>
        ${price}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

ProviderPackageListItem.propTypes = {
  providerPackage: PropTypes.shape({
    price: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
}

export default ProviderPackageListItem
